export default __webpack_public_path__ + "static/media/SC제일.4b366a8c.svg";